import { useSyncExternalStore } from 'react';
import { Dimensions, type ScaledSize } from 'react-native';

// Match React Native Web's static-export dimensions. React reuses this snapshot
// for the first hydration render, then switches to the real viewport. Reading
// useWindowDimensions directly can select a different component tree on desktop.
const SERVER_DIMENSIONS: ScaledSize = Object.freeze({
    width: 0,
    height: 0,
    scale: 1,
    fontScale: 1,
});

const getServerSnapshot = () => SERVER_DIMENSIONS;
const getSnapshot = () => Dimensions.get('window');
const subscribe = (onChange: () => void) => {
    const subscription = Dimensions.addEventListener('change', onChange);
    return () => subscription.remove();
};

export function useHydratedWindowDimensions(): ScaledSize {
    // Native and client-only mounts use the current viewport immediately;
    // subscriptions retain normal resize/orientation/font-scale updates.
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
